let $ = jQuery;

window.onload = function () {
  document.querySelectorAll(".prdctfltr_add_scroll").forEach(function (el) {
    el.classList.remove("prdctfltr_down");
    el.style.display = "none";
  });
  document.querySelectorAll(".prdctfltr-up").forEach(function (el) {
    el.classList.remove("prdctfltr-up");
    el.classList.add("prdctfltr-down");
  });

  //preloader

  let preloader = document.getElementById("preloader");
  preloader.style.opacity = 0;
  setTimeout(() => {
    preloader.style.display = "none";
  }, 400);
};

function stickyHeader() {
  let header = document.querySelector("#masthead");
  (stickySidebar = document.querySelector("#cat-nav")),
    (stickyProduct = document.querySelector("#sticky")),
    (scrollUp = "sticky"),
    (scrollDown = "sticky-up"),
    (lastScroll = 0);

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 200) {
      header.classList.remove(scrollUp);
      header.classList.remove(scrollDown);
      return;
    }

    if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
      // down
      // console.log("down");
      header.classList.remove(scrollUp);
      stickySidebar.classList.remove(scrollUp);
      if (stickyProduct != null) {
        stickyProduct.classList.remove(scrollUp);
        stickyProduct.classList.add(scrollDown);
      }
      header.classList.add(scrollDown);
      stickySidebar.classList.add(scrollDown);
    } else if (
      currentScroll < lastScroll &&
      header.classList.contains(scrollDown) &&
      stickySidebar.classList.contains(scrollDown)
    ) {
      // up
      header.classList.remove(scrollDown);
      stickySidebar.classList.remove(scrollDown);
      if (stickyProduct != null) {
        stickyProduct.classList.remove(scrollDown);
        stickyProduct.classList.add(scrollUp);
      }
      header.classList.add(scrollUp);
      stickySidebar.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  });
}

function mobileMenu() {
  let el = document.querySelectorAll(".menu-toggle");
  for (var i = 0; i < el.length; i++) {
    el[i].addEventListener("click", function () {
      document.querySelector(".header__navigation").classList.toggle("active");
      // document.querySelector(".menu-open").classList.toggle("active");
      document.querySelector(".menu-bg").classList.toggle("active");
    });
  }
}

function productAccordion() {
  $(".custom-accordion__item").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find(".custom-accordion__content").slideUp(150);
    } else {
      $(".custom-accordion__item").removeClass("active");
      $(".custom-accordion__content").slideUp(150);
      $(this).toggleClass("active");
      $(this).find(".custom-accordion__content").slideDown(150);
    }
  })
}

function storesAccordion() {
  document.querySelectorAll(".stores__head").forEach((accordion) => {
    accordion.addEventListener("click", function () {
      this.parentElement.classList.toggle("active");
    });
  });
}

function storesMap() {
  document.querySelectorAll(".map-button").forEach((button) => {
    button.addEventListener("click", function () {
      //Mobile
      let mapMobile = this.nextElementSibling;
      document.querySelector(".map-mobile.show").classList.remove("show");
      mapMobile.classList.add("show");
      mapMobile.src = this.dataset.frame;
      //Desktop
      document.getElementById("map").src = this.dataset.frame;
    });
  });
}

function openSidebar() {
  let toggleSidebar = document.getElementById("shop-now");
  let sidebarMenu = document.getElementById("sidebar-menu");
  let triggerSection = document.getElementById("content");
  toggleSidebar.addEventListener("click", function () {
    triggerSection.classList.toggle("moved");
    sidebarMenu.classList.toggle("show");
  });
}

function sidebarMenu() {
  // let navChildrens = document.querySelectorAll(".cat-nav a");
  // navChildrens.forEach((elem) => {
  //   elem.addEventListener("click", function (event) {
  //     if (elem.nextElementSibling) {
  //       event.preventDefault();
  //       this.parentElement.classList.toggle("opened");
  //     }
  //   });
  // });

  $(".open_sub").on("click", function () {
    console.log("click");
    $(this).parent().toggleClass("opened");
  })
}

function getLastWord() {
  let str = document.querySelectorAll(".product_title.entry-title");
  str.forEach((word) => {
    word.innerHTML = word.textContent.replace(/(\w+?)$/, "<span>$1</span>");
  });
}

function homeHeroSlider() {
  document.querySelectorAll(".hero").forEach((element) => {
    let heroItem = new Glide(element, {
      type: "carousel",
      autoplay: 4000,
      animationDuration: 2000,
      startAt: 0,
      rewind: true,
      rewindDuration: 2000,
      perTouch: 1,
      perView: 1,
      gap: 0,
      bound: true,
    });

    // heroItem.on(["mount.after", "run"], () => {
    //   let curSlide = document.getElementById("hero-slide"),
    //     currentIndex = heroItem.index;
    //   curSlide.innerText = currentIndex + 1;
    // });
    heroItem.mount();
  });
}

function productThumbnailSlider() {
  document.querySelectorAll(".product-section__gallery").forEach((element) => {
    let productGallery = new Glide(element, {
      type: "carousel",
      startAt: 0,
      rewind: true,
      rewindDuration: 2000,
      perTouch: 1,
      perView: 1,
      gap: 0,
      autoheight: true,
      bound: true,
      breakpoints: {
        991: {
          perView: 2,
        },
        767: {
          perView: 1,
        },
      },
    });

    productGallery.on(["mount.after", "run"], () => {
      let curSlide = document.getElementById("thumbnail-slide"),
        currentIndex = productGallery.index;
      curSlide.innerText = currentIndex + 1;
    });

    if (window.innerWidth < 768) {
      // console.log("enabled");
      productGallery.mount();
    } else {
      // console.log("disabled");
      productGallery.disable();
    }
  });
}

function relatedProductsSlider() {
  document.querySelectorAll(".related__slider").forEach((element) => {
    let related = new Glide(element, {
      type: "carousel",
      startAt: 0,
      rewind: true,
      rewindDuration: 2000,
      perTouch: 1,
      perView: 4,
      gap: 0,
      bound: true,
      dragThreshold: 30,
      swipeThreshold: 30,
      breakpoints: {
        991: {
          perView: 2,
        },
        767: {
          perView: 1,
        },
      },
    });

    related.on(["mount.after", "run"], () => {
      let curSlide = document.getElementById("related-slide"),
        currentIndex = related.index;
      curSlide.innerText = currentIndex + 1;
    });

    related.mount();
  });
}

function bestsellersProductsSlider() {
  document.querySelectorAll(".bestsellers__slider").forEach((element) => {
    let bestsellers = new Glide(element, {
      type: "carousel",
      startAt: 0,
      rewind: true,
      rewindDuration: 4000,
      perTouch: 1,
      perView: 3,
      gap: 0,
      bound: true,
      dragThreshold: 30,
      swipeThreshold: 30,
      breakpoints: {
        1350: {
          perView: 3,
        },
        1200: {
          perView: 3,
        },
        991: {
          perView: 2,
        },
        767: {
          perView: 1,
        },
      },
    });

    bestsellers.on(["mount.after", "run"], () => {
      let curSlide = document.getElementById("bestsellers-slide"),
        currentIndex = bestsellers.index;
      curSlide.innerText = currentIndex + 1;
    });

    bestsellers.mount();
  });
}

function newArrivalsProductsSlider() {
  document.querySelectorAll(".new-arrivals__slider").forEach((element) => {
    let newArrivals = new Glide(element, {
      type: "carousel",
      startAt: 1,
      rewind: true,
      rewindDuration: 4000,
      perTouch: 1,
      perView: 3,
      gap: 0,
      bound: true,
      dragThreshold: 30,
      swipeThreshold: 30,
      breakpoints: {
        1350: {
          perView: 3,
        },
        1200: {
          perView: 3,
        },
        991: {
          perView: 2,
        },
        767: {
          perView: 1,
        },
      },
    });

    newArrivals.on(["mount.after", "run"], () => {
      let curSlide = document.getElementById("newArrivals-slide"),
        currentIndex = newArrivals.index;
      curSlide.innerText = currentIndex + 1;
    });

    newArrivals.mount();
  });
}

function collectionsLinks() {
  let firstSrc = document.querySelector(".season_item.active"),
    catImage = document.getElementById("collectionImage");
  if (firstSrc) {
    catImage.src = firstSrc.dataset.src;
    document.querySelectorAll(".season_item").forEach((item) => {
      item.addEventListener("click", function () {
        // remove class
        document
          .querySelector(".season_item.active")
          .classList.remove("active");
        // add class
        this.classList.add("active");
        // set image
        catImage.src = this.dataset.src;
      });
    });
  }
}

function popupVideo() {
  let $ = jQuery;

  $(".popup-video").magnificPopup({
    // disableOn: 700,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: true,
    fixedContentPos: false,
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>' +
        "</div>",
      patterns: {
        youtube: {
          index: "youtube.com/",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1&muted=1",
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1&muted=1",
        },
      },

      srcAction: "iframe_src",
    },
  });

  // document.querySelectorAll(".popup-video").forEach((element) => {

  // });
}

stickyHeader();
mobileMenu();
homeHeroSlider();
productAccordion();
storesAccordion();
storesMap();
openSidebar();
sidebarMenu();
getLastWord();
// window.addEventListener("resize", productThumbnailSlider());
relatedProductsSlider();
bestsellersProductsSlider();
newArrivalsProductsSlider();
collectionsLinks();
popupVideo();
